import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
// import { userStore } from '@/store/index';
router.beforeEach((to, from, next) => {
  let token = sessionStorage.getItem('token');
  if (token != '' && token != null) {
    // 判断是否是移动端
    const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // 如果是移动端但访问PC端路由，重定向到移动端
    if (isMobile && !to.path.startsWith('/mobile') && to.path !== '/login') {
      next('/mobile');
      return;
    }
    
    // 如果是PC端但访问移动端路由，重定向到PC端首页
    if (!isMobile && to.path.startsWith('/mobile')) {
      next('/');
      return;
    }
    
    next();
  } else {
    if (to.path === '/login') {
      next();
    } else {
      next('/login');
    }
  }
  // const store = userStore();
  // console.log(store ,'store')
  // //判断是否有权限返回登录界面
  // if (from.meta.isAuth) {
  //     if (store.userInfo.token) {
  //         next()
  //     } else {
  //         next("/login")
  //     }
  // } else {
  //     console.log("没有权限");
  //     next()
  // }
})
export default router
